module.exports = __webpack_public_path__ + "static/media/5.19a87783.png";